import {
    getMethod,
    postMethod,
    putMethod,
    deleteMethod
} from "../../api-service/api-service";

import {
    setBlogs,
    setSelectedBlog,
    addBlog,
    updateBlog as updateBlogReducer,
    removeBlog as removeBlogReducer,
    setLoading
} from "./blogSlice";

/**
 * GET ALL BLOGS
 */
export const fetchAllBlogsAction = () => async (dispatch) => {
    try {

        dispatch(setLoading(true));

        const response = await getMethod("/blog");

        if (response?.success) {
            dispatch(setBlogs(response?.blogs));
        }

        dispatch(setLoading(false));

        return response;

    } catch (error) {
        console.log("Error:", error);
        dispatch(setLoading(false));
        return { success: false };
    }
};


/**
 * GET BLOG DETAILS
 */
export const fetchBlogDetailsAction = (id) => async (dispatch) => {

    try {

        dispatch(setLoading(true));

        const response = await getMethod(`/blog/${id}`);

        if (response?.success) {
            dispatch(setSelectedBlog(response?.blog));
        }

        dispatch(setLoading(false));

        return response;

    } catch (error) {
        console.log("Error:", error);
        dispatch(setLoading(false));
        return { success: false };
    }
};


/**
 * CREATE BLOG
 */
export const createBlogAction = (data) => async (dispatch) => {

    try {

        const response = await postMethod("/blog", data);

        if (response?.success) {
            dispatch(addBlog(response.data));
        }

        return response;

    } catch (error) {
        console.log("Error:", error);
        return { success: false };
    }
};


/**
 * UPDATE BLOG
 */
export const updateBlogAction = (id, data) => async (dispatch) => {

    try {

        const response = await putMethod(`/blog/${id}`, data);

        if (response?.success) {
            dispatch(updateBlogReducer(response.data));
        }

        return response;

    } catch (error) {
        console.log("Error:", error);
        return { success: false };
    }
};


/**
 * DELETE BLOG
 */
export const removeBlogAction = (id) => async (dispatch) => {

    try {

        const response = await deleteMethod(`/blog/${id}`);

        if (response?.success) {
            dispatch(removeBlogReducer(id));
        }

        return response;

    } catch (error) {
        console.log("Error:", error);
        return { success: false };
    }
};